const dba = {
  AGENCY_DIGIT_NUMERIC_ALSO_WITH_X: {
    message: 'Agency digit must be numeric or x',
    field: 'agency_digit',
    variable: undefined,
    code: 'DBA_1'
  },
  ACCOUNT_DIGIT_NUMERIC_ALSO_WITH_X: {
    message: 'Account digit is required and must be numeric or x',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_2'
  },
  AGENCY_ONE: {
    message: 'Agency must be 1',
    variable: undefined,
    field: 'agency',
    suggestion: '1',
    code: 'DBA_3'
  },
  INVALID_AGENCY_ONE: {
    message: 'Agency must be 1',
    variable: undefined,
    field: 'agency',
    suggestion: '1',
    code: 'DBA_3'
  },
  AGENCY_MAX_LENGTH: {
    message: 'Agency is required and must contain a maximum of {{maxLength}} numbers',
    field: 'agency',
    variable: 'maxLength',
    code: 'DBA_4'
  },
  AGENCY_DIGIT_NUMERIC: {
    message: 'Agency digit must be only 1 digit',
    field: 'agency_digit',
    variable: undefined,
    code: 'DBA_5'
  },
  ACCOUNT_MAX_LENGTH: {
    message: 'Account is required and must have a maximum of {{maxLength}} numbers',
    field: 'account',
    variable: 'maxLength',
    code: 'DBA_6'
  },
  ACCOUNT_MAX_MIN_LENGTH: {
    message: 'Account is required and must have between {{minLength}} and {{maxLength}} numbers',
    field: 'account',
    variable: ['maxLength', 'minLength'],
    code: 'DBA_7'
  },
  ACCOUNT_DIGIT_NUMERIC: {
    message: 'Account digit is required and must be only 1 digit',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_8'
  },
  ACCOUNT_EXACT_LENGTH: {
    message: 'Account is required and must contain exactly {{exactLength}} numbers',
    field: 'account',
    variable: 'exactLength',
    code: 'DBA_9'
  },
  ACCOUNT_TYPE: {
    message: 'Invalid account type',
    field: 'account_type',
    variable: undefined,
    code: 'DBA_10'
  },
  ACCOUNT_TYPE_2: {
    message: 'Invalid account type',
    field: 'account_type',
    variable: undefined,
    code: 'DBA_10'
  },
  ACCOUNT_TYPE_3: {
    message: 'Invalid account type',
    field: 'account_type',
    variable: undefined,
    code: 'DBA_10'
  },
  ENTIDADE_PUBLICA_IS_JUST_FOR_CNPJ: {
    message: "Account type 'Entidade pública' is only available for CNPJ",
    field: 'account_type',
    variable: undefined,
    code: 'DBA_11'
  },
  ENTIDADE_PUBLICA_IS_JUST_FOR_CNPJ_2: {
    message: "Account type 'Entidade pública' is only available for CNPJ",
    field: 'account_type',
    variable: undefined,
    code: 'DBA_11'
  },
  INVALID_DOCUMENT: {
    message: 'Destination bank account document is not a CPF nor CNPJ',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_12'
  },
  INVALID_DOCUMENT_2: {
    message: 'Destination bank account document is not a CPF nor CNPJ',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_12'
  },
  INVALID_DOCUMENT_3: {
    message: 'Destination bank account document is not a CPF nor CNPJ',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_12'
  },
  DOCUMENT_BLACKLIST_BLOCKED: {
    message: 'Destination bank account document is blocked',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_13'
  },
  DOCUMENT_BLACKLIST_BLOCKED_2: {
    message: 'Document {{docment}} is blocked',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_13'
  },
  BANK_NOT_FOUND: {
    message: 'Bank(s) not found by id or code',
    field: 'bank',
    variable: undefined,
    code: 'DBA_14'
  },
  INVALID_NAME: {
    message: 'The name is required',
    field: 'name',
    variable: undefined,
    code: 'DBA_15'
  },
  INVALID_EMAIL: {
    message: 'The email must be valid',
    field: 'email',
    variable: undefined,
    code: 'DBA_16'
  },
  EDIT_NOT_ALLOWED: {
    message: 'Destination Bank Account cannot be edited when status is Pending Verification or Verified',
    field: 'status',
    variable: undefined,
    code: 'DBA_17'
  },
  REMOVE_NOT_ALLOWED_WITH_PROCESSING_TRANSFERS: {
    message: 'Destination Bank Account cannot be removed while having processing transfers',
    field: undefined,
    variable: undefined,
    code: 'DBA_18'
  },
  INVALID_AGENCY_DIGIT: {
    message: 'Invalid agency digit',
    field: 'agency_digit',
    variable: undefined,
    code: 'DBA_19'
  },
  ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Invalid account or account digit',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_20'
  },
  INVALID_ACCOUNT_DIGIT: {
    message: 'Invalid account or account digit',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_20'
  },
  INVALID_ACCOUNT: {
    message: 'Invalid account',
    field: 'account',
    variable: undefined,
    code: 'DBA_21'
  },
  AGENCY_DOES_NOT_EXIST: {
    message: 'Agency does not exist',
    field: 'agency',
    variable: undefined,
    code: 'DBA_22'
  },
  DOCUMENT_DOEST_NOT_EXIST: {
    message: 'Document does not exist',
    field: 'cpf_cnpj',
    variable: undefined,
    code: 'DBA_23'
  },
  DOCUMENT_DOEST_NOT_EXIST_2: {
    message: 'Document {{document}} not found',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_23'
  },
  WRONG_DOCUMENT: {
    message: 'Informed document does not match with informed name',
    field: 'name',
    variable: undefined,
    code: 'DBA_24'
  },
  EMPTY_PAYLOAD: {
    message: 'Payload is required',
    field: undefined,
    variable: undefined,
    code: 'DBA_25'
  },
  INVALID_ACCOUNT_BEGINNING: {
    message: 'Invalid account. Account beginning {{accountBeginning}} is not valid',
    field: 'account',
    variable: 'accountBeginning',
    code: 'DBA_26'
  },
  INVALID_LEGAL_DOCUMENT: {
    message: 'Invalid legal {{document}} document',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_27'
  },
  INVALID_PHYSICAL_DOCUMENT: {
    message: 'CPF {{document}} is invalid',
    field: 'cpf_cnpj',
    variable: 'document',
    code: 'DBA_28'
  },
  AGENCY_ACCOUNT_TYPE_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Invalid agency, account type, account or account digit',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_29'
  },
  AGENCY_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Invalid agency, account or account digit',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_30'
  },
  AGENCY_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID_2: {
    message: 'Invalid agency, account or account digit',
    field: 'account_digit',
    variable: undefined,
    code: 'DBA_30'
  },
  PROVIDED_BANK_ID_AND_CODE: {
    message: 'Destination Bank Account was provided with bank id and code, please provide only one bank info.',
    field: 'bank_id',
    variable: undefined,
    code: 'DBA_31'
  },
  ACCOUNT_IS_JUST_FOR_CNPJ: {
    message: 'Destination Bank Account belongs to a company (CNPJ).',
    field: 'account',
    variable: undefined,
    code: 'DBA_32'
  },
  BANK_CODE_FORMAT_ERROR: {
    message: 'Bank Code is required and must have a maximum of 3 numbers',
    field: 'bank_code',
    variable: undefined,
    code: 'DBA_33'
  },
  BANK_CODE_NOT_FOUND: {
    message: 'This banking institution is not eligible to receive payments',
    field: 'bank_code',
    variable: undefined,
    code: 'DBA_34'
  },
  INVALID_NAME_LENGTH: {
    message: 'The name must have at least 3 characters',
    field: 'name',
    variable: undefined,
    code: 'DBA_35'
  },
  INVALID_BANK_ID: {
    message: 'Bank ID must be a number',
    field: 'bank_id',
    variable: undefined,
    code: 'DBA_36'
  },
  REQUIRED_PIX_KEY_TYPE: {
    message: 'The Pix key type is required',
    field: 'pix_key_type',
    code: 'DBA_37'
  },
  REQUIRED_PIX_KEY_VALUE: {
    message: 'The Pix key value is required',
    field: 'pix_key',
    code: 'DBA_38'
  },
  INVALID_PIX_KEY_TYPE: {
    message: 'The Pix key type is invalid',
    field: 'pix_key_type',
    code: 'DBA_39'
  },
  INVALID_PIX_KEY: {
    message: 'The Pix key value is invalid for the key type {{pix_key_type}}',
    field: 'pix_key',
    variable: 'pix_key_type',
    code: 'DBA_40'
  },
  BANK_ISPB_FORMAT_ERROR: {
    message: 'Bank ISPB is required and must have exactly 8 numbers',
    field: 'bank_ispb',
    variable: undefined,
    code: 'DBA_41'
  },
  BANK_ISPB_NOT_FOUND: {
    message: 'This banking institution is not eligible to receive payments',
    field: 'bank_ispb',
    variable: undefined,
    code: 'DBA_42'
  },
  BANK_ISPB_ONLY_PIX_ALLOWED: {
    message: 'This banking institution is only eligible to receive payments using Pix',
    field: 'bank_ispb',
    variable: undefined,
    code: 'DBA_43'
  },
  PROVIDED_BANK_CODE_AND_ISPB: {
    message: 'Destination Bank Account was provided with bank code and ISPB, please provide only one bank info',
    field: 'bank_code',
    variable: undefined,
    code: 'DBA_44'
  },
  EMPTY_BANK_CODE_AND_ISPB: {
    message: 'Bank code or ISPB are required',
    field: 'bank_code',
    variable: undefined,
    code: 'DBA_45'
  },
  PROVIDED_BANK_ID_AND_ISPB: {
    message: 'Destination Bank Account was provided with bank id and ISPB, please provide only one bank info',
    field: 'bank_id',
    variable: undefined,
    code: 'DBA_46'
  },
  BANK_ONLY_TED_TEV_ALLOWED: {
    message: 'This banking institution is only eligible to receive payments using TED/TEV',
    field: 'bank_id',
    variable: undefined,
    code: 'DBA_47'
  },
  DOCUMENT_INCONSISTENT_STATUS: {
    message: 'Inconsistency in the registration status of the document',
    field: 'cpf_cnpj',
    code: 'DBA_48'
  }
};

module.exports = dba;
